export const SALONBUSINESSCPA_ACCOUNTANT_ROLE = "salonbusinesscpa_accountant";

export function isSalonBusinessCpaAccountant(value = null) {
  const role =
    typeof value === "string"
      ? value
      : value?.role || value?.user?.role || "";
  return String(role || "").trim().toLowerCase() === SALONBUSINESSCPA_ACCOUNTANT_ROLE;
}

export function isAccountingOnlyAccountant(user = null, role = "") {
  return (
    isSalonBusinessCpaAccountant(role || user?.role) &&
    !Boolean(user?.is_super_admin)
  );
}
